import { SideBarItems } from '../shared';

const defaultState = {
    activeItem: SideBarItems.NONE
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'SET_ACTIVE_SIDEBAR_ITEM': {
            return {
                ...state,
                activeItem: action.payload
            };
        }
        case 'ACTIVATE_SIDEBAR': {
            return {
                ...state,
                activeItem: state.activeItem === SideBarItems.NONE || state.activeItem === SideBarItems.ACTIVE ? SideBarItems.ACTIVE : SideBarItems.BLOK_EDITOR
            };
        }
        default: {
            return state;
        }
    }
}
